module.exports = __webpack_public_path__ + "static/media/collaborator-home.d2440481.svg";